// extracted by mini-css-extract-plugin
module.exports = {"container":"radio_container__3G23O","option":"radio_option__1q4fV","span":"radio_span__3ytSb","disabled":"radio_disabled__2TY17"};